import type { ServerTableResponse } from "./server-table";

/**
 * Cursor-paginated API payload. When the endpoint can compute an exact total
 * for the requested filters it fills `count`; otherwise it stays null and the
 * consumer treats it as "no total" - navigation never derives from it.
 */
export interface CursorPageResponse<T> {
  data: T[];
  has_more: boolean;
  next_cursor: string | null;
  count?: number | null;
}

/**
 * Normalizes a cursor-paginated API payload into what the DataTable needs.
 * The server total is repassed verbatim (or null when absent/non-finite):
 * no heuristic, no invented number.
 */
export function toServerTableResponse<T>(
  response: CursorPageResponse<T>,
): ServerTableResponse<T> {
  const exact =
    typeof response.count === "number" && Number.isFinite(response.count)
      ? response.count
      : null;

  return {
    data: response.data,
    count: exact,
    has_more: response.has_more,
    next_cursor: response.next_cursor,
  };
}
